import { HierarchyFilter } from '../types';

export const getFilterExpression = (treeItem: any, filterResults?: HierarchyFilter): boolean => {
    switch (filterResults?.operator) {
        case '==': {
            // eslint-disable-next-line eqeqeq
            return treeItem?.[filterResults?.key] == filterResults?.value;
        }
        case '===': {
            return treeItem?.[filterResults?.key] === filterResults?.value;
        }
        case '!=': {
            // eslint-disable-next-line eqeqeq
            return treeItem?.[filterResults?.key] != filterResults?.value;
        }
        case '!==': {
            return treeItem?.[filterResults?.key] !== filterResults?.value;
        }
        case '>': {
            return treeItem?.[filterResults?.key] > filterResults?.value;
        }
        case '<': {
            return treeItem?.[filterResults?.key] < filterResults?.value;
        }
        case '>=': {
            return treeItem?.[filterResults?.key] >= filterResults?.value;
        }
        case '<=': {
            return treeItem?.[filterResults?.key] <= filterResults?.value;
        }
        case 'in': {
            return filterResults?.value?.includes(treeItem?.[filterResults?.key]);
        }
        case 'i==': {
            // case insensative
            const valueA: any = treeItem?.[filterResults?.key];
            const valueB: any = filterResults?.value;
            if (typeof valueA === 'string' && typeof valueB === 'string') {
                return valueA.toLowerCase() !== valueB.toLowerCase();
            }
            return true;
        }
        default: {
            return true;
        }
    }
};
